/**
 * devModeApi.ts - endpoints de devmode (reset data, debug helpers).
 * Reserve aux admins. Endpoint cache (pas dans la navigation).
 */
import { apiFetch } from './apiClient';

export type ResetScope = 'audit' | 'notifications' | 'all';

export interface ResetResponse {
  stats: {
    scope:        ResetScope;
    clientId:     string;
    scans:        number;
    alertHistory: number;
    alertRules:   number;
    manualDecs:   number;
    scanScope:    boolean;
    scanSchedule: boolean;
  };
  elapsedMs:    number;
  performedBy:  string;
  performedAt:  string;
  message:      string;
}

export const devModeApi = {
  reset: (scope: ResetScope) =>
    apiFetch<ResetResponse>('/devmode/reset', {
      method: 'POST',
      body:   JSON.stringify({ scope, confirm: true }),
      headers: { 'Content-Type': 'application/json' },
    }),
};
